/**
 * d16n::legacy
 * d16n::source:<PAssociatedProductCarousel.vue>
 * d16n::helpers-file
 */

import { useAnalyticService } from '@b2ag/plugin-aladin-gtm'
import type { EventPayload } from './typings'

function carouselAssociatedViewedPayload(payload: { productId: string; productName: string }) {
  return {
    date: new Date().toLocaleString('fr-FR').replace(', ', ' à '),
    product_name: payload.productName,
    page: {
      productId: payload.productId,
    },
  }
}

export function carouselAssociatedViewed(productId: string, productName: string, viewEventName?: string) {
  if (viewEventName) {
    const payload = {
      productId,
      productName,
    }
    useAnalyticService().trackEvent(viewEventName, carouselAssociatedViewedPayload(payload))
  }
}

export function productAssociatedClickPayload(eventPayload: EventPayload) {
  const { product, productId, actionFieldList } = eventPayload

  return {
    product_name: product.name,
    ecommerce: {
      click: {
        actionField: {
          list: actionFieldList,
        },
        dateTime: new Date().toLocaleString('fr-FR').replace(', ', ' à '),
        productId,
        products: [
          {
            id: product._id,
            name: product.name,
            supplier: product.supplier,
            kind: product.kind,
          },
        ],
      },
    },
  }
}
